import { render, staticRenderFns } from "./Mview.vue?vue&type=template&id=2bfd4e2a&"
import script from "./Mview.vue?vue&type=script&lang=js&"
export * from "./Mview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports